import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ICONS_PATH } from './icons-path';

// этот компонент для того что бы изменять svg помощью css свойств, в ангуляре не предусмотрен такое управление svg

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg[icon]',
  template: '<svg:use [attr.href]="href"></svg:use>',
  styles: [':host { fill: transparent; stroke: transparent; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  private readonly path = inject(ICONS_PATH);

  @Input()
  icon = '';

  get href(): string {
    return `${this.path}/${this.icon}.svg#${this.icon}`;
  }
}
